export enum NotificationPermission {
  GRANTED = "granted",
  DENIED = "denied",
  UNDETERMINED = "undetermined",
}

export interface User {
  firstName: string;
  lastName: string;
  sub?: string;
  memberNumber?: string;
}

export type AccessToken = string & { __brand: "AccessToken" };

export interface Authentication {
  getAccessToken(): Promise<AccessToken | null>;
  currentUser: User | null;
  login(): Promise<void>;
  logout(): Promise<void>;
}

export interface Impersonation {
  impersonatedUser: User | null;
  canImpersonate: boolean;
  assumeUser: (user: User) => void;
  clearAssumedUser: () => void;
}

export interface JobSearchHistory {
  jobSearches: JobSearch[];
  addJobSearch(search: JobSearch): void;
  clearJobSearches(): void;
}

export interface UserAcknowledgements {
  acknowledgedNotificationBadgeState: NotificationPermission;
  setAcknowledgedNotificationBadgeState(state: NotificationPermission): void;
  acknowledgedEmailChangeExpired: boolean;
  setAcknowledgedEmailChangeExpired(state: boolean): void;
}

export interface UserContextValue extends Authentication, Impersonation, JobSearchHistory, UserAcknowledgements {
  initialized: boolean;
}

export type JobSection = { type: "section"; name: string };
export type JobPlace = { type: "place"; name: string; miles: number; lat: number; lng: number };
export type JobLocation = JobSection | JobPlace;

export interface JobSearch {
  text?: string;
  location?: JobLocation;
}
